module.exports = __webpack_public_path__ + "static/img/Jordan_De_Goey_desktop.58ee1ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jordan_De_Goey_desktop.jpg
// module id = EV+u
// module chunks = 0